import axios from "axios";

// Derive .../api/auth from the same host as REACT_APP_API_BASE_URL
// (.../api/kundli), same pattern as walletApi.js.
const KUNDLI_BASE = process.env.REACT_APP_API_BASE_URL || "";
const AUTH_BASE = KUNDLI_BASE.replace(/\/api\/kundli\/?$/, "/api/auth");

export const authApi = axios.create({
  baseURL: AUTH_BASE,
  headers: { "Content-Type": "application/json" },
});

const unwrap = (promise) =>
  promise
    .then((res) => res.data)
    .catch((err) => {
      const body = err.response?.data;
      const message = body?.message || body?.detail || "Something went wrong.";
      throw { message, errors: body?.errors, status: err.response?.status };
    });

// POST /api/auth/login/  { email, password }
// -> { success, data: { step: "login_complete" | "signup_incomplete", tokens, user } }
export const loginWithEmail = (email, password) =>
  unwrap(authApi.post("/login/", { email, password }));

// POST /api/auth/complete-profile/  { full_name, ... }  (requires Bearer token)
// -> { data: { step: "signup_complete", tokens, user } }
export const completeProfile = (payload, accessToken) =>
  unwrap(
    authApi.post("/complete-profile/", payload, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
  );

// POST /api/auth/token/refresh/  { refresh }
// -> { access, refresh }  — Django SimpleJWT built-in TokenRefreshView.
// ROTATE_REFRESH_TOKENS is on in settings.py, so a new refresh token comes back
// every time — always save both, never just the access token.
export const refreshAccessToken = (refresh) =>
  unwrap(authApi.post("/token/refresh/", { refresh }));

// ── Legacy OTP stubs — kept so old imports do not crash at build time ──
// OTP login is no longer supported. Backend endpoints are commented out.
export const sendOtp = () =>
  Promise.reject({ message: "OTP login is no longer supported." });
export const verifyOtp = () =>
  Promise.reject({ message: "OTP login is no longer supported." });
